// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3_pVshMBUDZeHn {\n  position: absolute;\n  top: 0;\n  bottom: 10px;\n  right: 10px;\n  left: 10px;\n  border-radius: 3px;\n}\n._3_pVshMBUDZeHn._3PBSCYDMxt9O5V {\n  left: calc(16px + 10px);\n}\n._3_pVshMBUDZeHn > div {\n  border-radius: 3px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "_3_pVshMBUDZeHn",
	"collapsedWorkspaceNavigation": "_3PBSCYDMxt9O5V"
};
export default ___CSS_LOADER_EXPORT___;
